import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { SignatureRequest } from '@app/models/documents/signature-request.model';
import { PlatformModule } from '@app/platform.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    standalone: true,
    imports: [CommonModule, PlatformModule, TranslateModule],
    selector: 'app-document-multi-signer-status',
    templateUrl: './multi-signer-status.template.html',
    styleUrls: ['./multi-signer-status.style.scss'],
})
export class MultiSignerStatusComponent {
    @Output() remind: EventEmitter<SignatureRequest> = new EventEmitter<SignatureRequest>();
    allRequests: SignatureRequest[] = [];
    hasOrdering = false;

    showRemind(request: SignatureRequest): boolean {
        if (this.hasTerminatedEmployee()) {
            return false;
        }

        if (!this.hasOrdering) {
            return true;
        }

        return this.allRequests.find((r: SignatureRequest) => !r.isSigned()).is(request);
    }

    hasTerminatedEmployee(): boolean {
        return this.allRequests.some(({ employee }) => employee.isTerminated());
    }

    onRemind(signature: SignatureRequest): void {
        this.remind.emit(signature);
    }

    combineRequestWithCosignersForDisplay(signatureRequest: SignatureRequest): void {
        const requests = [signatureRequest, ...signatureRequest.cosigners];
        this.hasOrdering = requests.some((request: SignatureRequest) => !!request.order);

        if (this.hasOrdering) {
            requests.sort((a: SignatureRequest, b: SignatureRequest) => (a.order && b.order ? a.order - b.order : 0));
        }

        this.allRequests = requests;
    }
}
